export enum PromptActionsType {
  Dismiss = 'Dismiss',
  Reload = 'Reload',
  Redirect = 'Redirect',
  Custom = 'Custom'
}
